import React from 'react';
// Redux
import { useDispatch } from 'react-redux';
import { GsProductFilters } from '../../../redux/types/filtersTypes';
import { setFilters, resetFilters } from '../../../redux/actions/FiltersActions';
// App
import DashboardComponent from '../../../components/DashboardComponent';
import GsProductListComponent from '../../../components/Products/GsProductListComponent';
// Other
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

export default function GsProductList(props: RouteComponentProps) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setFilters(new GsProductFilters()));
    return () => {
      dispatch(resetFilters())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardComponent
      title={<h2>Productos</h2>}
      children={<Switch>
        <Route exact path={props.match.path + '/list'} component={GsProductListComponent} />
        <Redirect to={props.match.path + '/list'} />
      </Switch>}
    />
  );
}

